export const MOUSEDOWN_EVENT_CUSTOM_DATA_KEY = "eventCustomData";

export interface MouseDownEventCustomDataInterface {
    isDialogTextarea?: boolean;
    templatesLabel?: string;
    templates?: MouseDownItemTemplatesItemInterface[];
    copyAvailable?: boolean;
    pasteAvailable?: boolean;
}

export interface MouseDownItemTemplatesItemInterface {
    id?: string;
    descr: string;
    templates: {
        id: string;
        descr: string;
    }[]
}